import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { LocationTrackerCompanionPushEffects } from './effects/location-tracker-companion-push.effects';
import { LocationTrackerEffects } from './effects/location-tracker.effects';
import { locationTrackerReducer } from './reducers/location-tracker.reducer';
import { LOCATION_TRACKER_FEATURE_KEY } from './location-tracker.state';

/**
 * Registers the location-tracker feature slice — a pure page-state slice with no persistence and
 * no HTTP of its own. Both storage keys the page touches (`LocationTracker` and
 * `LocationTrackerState`) are owned by the user-store slice (`UserStoreStoreModule`), which is
 * already registered with `PaceOfflineModule` for `ENDPOINTS.AzUserStore`; this module only
 * registers the reducer and the two effects classes that read/write through the user store.
 *
 * `LocationTrackerEffects` seeds the page's draft from the user store and owns the geolocation
 * lookup used to fill in the privacy perimeter. `LocationTrackerCompanionPushEffects` notifies the
 * companion iOS app of timesheet events and records the derived work-day timestamps.
 */
@NgModule({
    imports: [
        StoreModule.forFeature(LOCATION_TRACKER_FEATURE_KEY, locationTrackerReducer),
        EffectsModule.forFeature([LocationTrackerEffects, LocationTrackerCompanionPushEffects]),
    ],
})
export class LocationTrackerStoreModule {}
